import { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import "./nav.css";
import mv from "../../assets/mv.svg";
import LightModeIcon from "@mui/icons-material/LightMode";
import NightsStayIcon from "@mui/icons-material/NightsStay";

export const Nav = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const toggleDarkMode = () => {
    setDarkMode(!darkMode);
    document.body.classList.toggle("dark-mode", !darkMode);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const closeMenu = () => {
    setMenuOpen(false);
  };

  return (
    <header className="nav-header">
      <nav className="navbar_container container">
        <input
          type="checkbox"
          id="menu-toggle"
          checked={menuOpen}
          onChange={toggleMenu}
        />
        <div className="logo">
          <Link to="/" onClick={closeMenu}>
            <img src={mv} alt="Brand Logo" />
          </Link>
        </div>

        <label htmlFor="menu-toggle" className="hamburger-lines">
          <span className="line line1"></span>
          <span className="line line2"></span>
          <span className="line line3"></span>
        </label>
        <ul className={`menu-items ${menuOpen ? "open" : ""}`}>
          <li>
            <NavLink
              to="/"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Home
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/about"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              About
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/rooms"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Rooms
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/gallery"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Gallery
            </NavLink>
          </li>
          <li>
            <NavLink
              to="/contact"
              className={({ isActive }) => (isActive ? "active" : "")}
              onClick={closeMenu}
            >
              Contact
            </NavLink>
          </li>
        </ul>
        <div className="bookNow-btn">
          <button onClick={(e) => navigate("/booknow")}>Book Now</button>
        </div>
        <div className="dark-mode-toggle" onClick={toggleDarkMode}>
          {darkMode ? (
            <LightModeIcon fontSize="medium" className="text-white" />
          ) : (
            <NightsStayIcon fontSize="medium" className="text-danger" />
          )}
        </div>
      </nav>
    </header>
  );
};
